module.exports = __webpack_public_path__ + "static/icon3-5546935d95807aa73515978dad6417e2.svg";